import z from 'zod';
import { UUIDSchema, UnixTimestampSchema } from '../common/schemas';
import { DBNumericSchema, DBTimestampSchema, PageFractionSchema } from '../common/sql';

/**
 * DB Schemas
 *
 * An occurrence is a sighting of a question in a paper, not a question. A
 * duplicate appends one of these to the canonical question rather than creating
 * a second.
 */

export const DBQuestionOccurrenceSchema = z.object({
  id: UUIDSchema,
  rootQuestionId: UUIDSchema,
  sourceDocumentId: UUIDSchema,
  sequenceInDocument: z.number().int().positive(),
  originalQuestionId: z.string().min(1).max(64),
  originalQuestionNumber: z.string().min(1).max(64),
  snippetAssetId: UUIDSchema.nullable(),
  createdAt: DBTimestampSchema,
});

export const DBOccurrenceRegionSchema = z.object({
  id: UUIDSchema,
  occurrenceId: UUIDSchema,
  questionId: UUIDSchema.nullable(),
  pageNumber: z.number().int().positive(),
  bboxX0: DBNumericSchema,
  bboxY0: DBNumericSchema,
  bboxX1: DBNumericSchema,
  bboxY1: DBNumericSchema,
  position: z.number().int().min(0),
  createdAt: DBTimestampSchema,
});

/**
 * Client Schemas
 */

export const QuestionOccurrenceOriginalQuestionIdSchema = z.string().min(1).max(64).openapi({
  description:
    'The identifier the source paper gives the question, composed through its ancestors, such as 21 or 1(c)',
  example: '21',
});

export const QuestionOccurrenceOriginalQuestionNumberSchema = z.string().min(1).max(64).openapi({
  description:
    'The identifier the paper prints above this question, such as 1 for the sighting named 1(c)',
  example: '1',
});

export const QuestionOccurrenceSchema = z.object({
  id: UUIDSchema,
  rootQuestionId: UUIDSchema,
  sourceDocumentId: UUIDSchema,
  sequenceInDocument: z.number().int().positive(),
  originalQuestionId: QuestionOccurrenceOriginalQuestionIdSchema,
  originalQuestionNumber: QuestionOccurrenceOriginalQuestionNumberSchema,
  snippetAssetId: UUIDSchema.nullable(),
  createdAt: UnixTimestampSchema,
});

export const OccurrenceRegionSchema = z.object({
  id: UUIDSchema,
  occurrenceId: UUIDSchema,
  questionId: UUIDSchema.nullable(),
  pageNumber: z.number().int().positive(),
  bboxX0: PageFractionSchema,
  bboxY0: PageFractionSchema,
  bboxX1: PageFractionSchema,
  bboxY1: PageFractionSchema,
  position: z.number().int().min(0),
  createdAt: UnixTimestampSchema,
});
